import { Box, styled } from '@mui/material';
import { NavLink } from 'components';

export const StyledNavbar = styled(Box)(({ theme }) => ({
  order: 1,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    order: 2,
    gap: theme.spacing(1),
    justifyContent: 'space-between',
  },
}));

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.grey[500],
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
  '&.active': {
    color: theme.palette.primary.main,
    borderBottom: '2px solid',
    borderBottomColor: 'inherit',
  },
}));
